export const GET_SIDELINES_API =  'GET_SIDELINES_API';
export const GET_DIPS_API =  'GET_DIPS_API';
export const GET_DRINKS_API =  'GET_DRINKS_API';
export const GET_SWEET_SOME_THINGS_API =  'GET_SWEET_SOME_THINGS_API';
